import { defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import { PopupWrapper } from '@hems/component';
import { TermsService, UserInfoService } from '@hems/service';
import { TermsHelper, useLanguage, useLocale } from '@hems/util';
import { ENV_LOCALE, REQUIRED_TERMS_CATEGORY, TERMS_TYPE } from '@hems/util/src/constant';
import { getAccessToken } from '@hems/util/src/helper/authHelper';
export default defineComponent({
    name: 'PrivacyPopup',
    components: {
        PopupWrapper,
    },
    props: {
        className: {
            type: String,
            required: false,
            default: '',
        },
    },
    emits: ['close'],
    setup(props, { emit }) {
        const API_BASE_URL = process.env.VUE_APP_API_URL;
        const store = useStore();
        const axiosInstance = axios.create({
            baseURL: API_BASE_URL,
        });
        const termsService = new TermsService(axiosInstance);
        const userInfoService = new UserInfoService(axiosInstance);
        const { languageCode } = useLanguage();
        const { locale } = useLocale();
        const termsList = ref([]);
        const privacyPolicyTerms = ref();
        const selectedLocale = ref(locale);
        const positionClass = props.className === 'pos-ab' ? 'position: absolute;' : '';
        const getAccountCountryInfo = async () => {
            const userId = store.state.user.userId;
            const accessToken = getAccessToken();
            if (!userId || !accessToken)
                return;
            try {
                const accountCountryInfo = await userInfoService.getAccountCountryInfo(userId, accessToken);
                if (accountCountryInfo?.cntry_cd === ENV_LOCALE.NZ) {
                    selectedLocale.value = accountCountryInfo?.cntry_cd;
                }
            }
            catch (e) {
                console.error(e);
            }
        };
        const getTermsList = async () => {
            try {
                const terms = await termsService.getTerms(TERMS_TYPE.USER);
                termsList.value = TermsHelper.getSortedTermsByEffectiveDate(terms);
            }
            catch (e) {
                console.error(e);
            }
        };
        const setRequiredTerms = () => {
            const filteredTerms = TermsHelper.getFilteredTerms(termsList.value, selectedLocale.value, languageCode.value).requiredTerms;
            privacyPolicyTerms.value = filteredTerms[REQUIRED_TERMS_CATEGORY.TERMS_OF_PRIVACY];
        };
        const closePopup = () => {
            emit('close');
        };
        onMounted(async () => {
            await getAccountCountryInfo();
            await getTermsList();
            setRequiredTerms();
        });
        return {
            positionClass,
            termsList,
            privacyPolicyTerms,
            closePopup,
        };
    },
});
